import React, { useEffect, useState } from 'react'
import { Button } from "reactstrap";
import httpService from "../../../services/http.service";
import WarningMessage from "../../common/warnMsg";
import SuccessMessage from "../../common/successMsg";
import Navbar from './settingNav';
import ErrorMessage from '../../common/errorMsg';

const BillboardRef = (props) => {
    const [refreshTime, setRefreshTime] = useState(0);
    const [disable, setDisable] = useState(false)

    useEffect(() => {
        setRefreshTime(props.refreshTime)
    }, [props.refreshTime])

    const handleTime = (e) => {
        if (e.target.value.match(/[^0-9]/) === null && e.target.value.length <= 10 ) {   
            setRefreshTime(e.target.value);
            setDisable(false)
        }
    };

    const saveRefreshTime = async (e) => {
        if (refreshTime === "") {
            WarningMessage("Please Enter Correct Value")
            return;
        }
        if (refreshTime === props.refreshTime) return;
        setDisable(true)
       
        let data = {
            data: refreshTime
        };
        const timeData = await httpService.CreateUpdate("saveTime", data)
        if (timeData && timeData.data.ack == "1") {
            props.setRefreshTime(refreshTime)
            SuccessMessage(timeData.data.message)
        } else {
            ErrorMessage(timeData.data.message)
        }
        setDisable(false)
    };

    console.log("Refresh time : ", refreshTime)
    return (
        <div style={{ margin: "15px" }}>
            
            <Navbar activeTab={"billboardRef"} />
            <div className='pad-15 mt-5'>
                <div className="form-boxdiv ">
                    <div className="form-boxtopline5">Billboard RefreshTime</div>
                    <div className="form-boxtopcont ">
                        <div className="row">
                            <div className="col-sm-6">
                                <label>Set Time (min):</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Minutes..."
                                    pattern="[1-9]{1}[0-9]{9}"
                                    autoComplete='off'
                                    name="fixtime"
                                    onChange={(e) => { handleTime(e) }}
                                    value={refreshTime}
                                />
                                <Button
                                    color="success"
                                    className='mt-2 mr-2 mb-2'
                                    onClick={(e) => saveRefreshTime(e)}
                                    disabled={disable}
                                >  Save
                                </Button>
                                {/* <Button color="danger" className='mt-2' >
                                        Cancel
                                    </Button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="col-4"></div>
            <div className="text-end col-4" style={{ marginTop: "15px" }}></div>
        </div>
    )
}

export default BillboardRef